export default __webpack_public_path__ + "static/media/relative-medium-pro.03fe8a6a.woff2";